import { useCallback, useEffect, useState } from 'react';

export const useImageSliderMouseWithin = (ref: React.RefObject<HTMLElement>) => {
  const [isMouseWithin, setIsMouseWithin] = useState(true);

  const onMouseEnter = useCallback(() => {
    setIsMouseWithin(true);
  }, []);

  const onMouseLeave = useCallback(() => {
    setIsMouseWithin(false);
  }, []);

  useEffect(() => {
    if (ref.current) {
      (ref.current as HTMLElement).addEventListener('mouseenter', onMouseEnter, false);
      (ref.current as HTMLElement).addEventListener('mouseleave', onMouseLeave, false);
    }

    return () => {
      if (ref.current) {
        (ref.current as HTMLElement).removeEventListener('mouseenter', onMouseEnter, false);
        (ref.current as HTMLElement).removeEventListener('mouseleave', onMouseLeave, false);
      }
    };
  }, [ref.current, onMouseEnter, onMouseLeave]);

  return isMouseWithin;
};
